import { Controller } from "@hotwired/stimulus"

// Selecteert de hele waarde van een invoerveld bij een klik, zodat een link of
// sleutel in één handeling te kopiëren is.
export default class extends Controller {
  select() {
    this.element.select()
  }
}
